module.exports = __webpack_public_path__ + "static/media/20191114.b2b4305a.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20191114/img/20191114.png
// module id = 304
// module chunks = 0